<template>
    <div class="o-sms-modal-ready">
        <OSmsModalReadyHeaderValid 
            v-if="isValid"
            :item="item"
        />
        <OSmsModalReadyHeaderInvalid
            :value="value"
            v-else
        />
        <div class="sms-modal-ready__container">
            <MInputForm
                class="sms-modal-ready__input"
                v-model="localValue"
                icon
                @onDelete="handleDelete"
                @onChange="handleChange"
                :is-valid="isValid"
                placeholder="(000)000-00-00"
            >
                <template #icon>
                    <svg-icon
                        original
                        name="icons/phone"
                        class="sms-modal-ready__phone-icon"
                    />
                </template>
            </MInputForm>
            <div class="sms-modal-ready__wrapper">
                <div class="sms-modal-ready__codes">
                    <button
                        type="button"
                        role="button"
                        class="sms-modal-ready__country-button"
                        :class="{'sms-modal-ready__country-button--active': isActiveCode(button.code)}"
                        v-for="(button, index) in codes"
                        :key="index"
                        :aria-label="ariaLabel"
                        @click="handleChangeCode(button.code)"
                    >
                        <svg-icon
                            original
                            :name="`locales/${button.country}`"
                        />
                    </button>
                </div>
                <MSmsModalKeyboard
                    class="sms-modal-ready__keyboard"
                    @onClick="handleInput"
                />
            </div>
        </div>
    </div>
</template>

<script>
import MInputForm from '../../molecules/m-input-form/m-input-form';
import MSmsModalKeyboard from '../../molecules/m-sms-modal-keyboard/m-sms-modal-keyboard';
import OSmsModalReadyHeaderValid from '../o-sms-modal-ready-header-valid/o-sms-modal-ready-header-valid';
import OSmsModalReadyHeaderInvalid from '../../unique-organisms/o-sms-modal-ready-header-invalid/o-sms-modal-ready-header-invalid';

export default {
    name: "OSmsModalReady",
    components: {
        MInputForm,
        MSmsModalKeyboard,
        OSmsModalReadyHeaderValid,
        OSmsModalReadyHeaderInvalid
    },
    data() {
        return {
            codes: [
                {
                    code: '+46',
                    country: 'se'
                },
                {
                    code: '+358',
                    country: 'fi'
                },
                {
                    code: '+47',
                    country: 'nb'
                }
            ]
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        isValid: {
            type: Boolean,
            default: true
        },
        item: {
            type: String,
            default: ''
        },
        ariaLabel: {
            type: String,
            default: 'SMS modal ready country button'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    mounted() {
        this.localValue = this.codes[0].code;
    },
    methods: {
        isActiveCode(code) {
            return this.localValue.includes(code);
        },
        handleInput(val) {
            this.localValue += val;
        },
        handleChangeCode(code) {
            this.localValue = code;
        },
        handleDelete() {
            if(this.localValue.length !== 0) {
                this.localValue = this.localValue.substring(0, this.localValue.length - 1)
            }
        },
        handleChange() {
            this.$emit('onChange', true);
        }
    }
}
</script>

<style lang="scss">
@import "o-sms-modal-ready";
</style>
